import React, { useState, useEffect } from "react";
import { Box, Button, Typography, TextField } from "@mui/material";
import { addCompanyApi } from "../../../api/company";
import Popup from "../../../component/popup/Popup.js";

const buttonStyle = {
    borderRadius: "10px",
    lineHeight: "normal",
    my: 1,
};
const textFieldStyle = {
    my: 1,
    ml: 1,
    flex: 1,
    borderRadius: "4px",
    "& .MuiInputBase-input": {
        py: 0.5,
        px: 0,
    },
    "& .MuiInputBase-root": {
        px: 2,
        py: 0,
    },
};
const AddNewCompanyPopup = ({
    open,
    onClose,
    options,
    onSetSuccess,
    onSetError,
}) => {
    const [companyList, setCompanyList] = useState(options || []);
    const [addNewCompanyName, setAddNewCompanyName] = useState("");

    const addNewCompany = async () => {
        const trimmedName = addNewCompanyName.trim();
        if (!trimmedName) {
            onSetError("The company name can't be empty.");
            return;
        }

        const isDuplicate = companyList.some(
            (item) => item.label.trim().toLowerCase() === trimmedName.toLowerCase()
        );

        if (isDuplicate) {
            onSetError("This company has already been assigned.");
            return;
        }
        try {
            addCompanyApi(addNewCompanyName);
            onSetSuccess("The new company has been successfully added.");
            setCompanyList((prevData) => [...prevData, { label: addNewCompanyName }]);
            setAddNewCompanyName("");
            onClose();
        } catch {
            onSetError("Add new company failed.");
        }
    };

    useEffect(() => {
        setCompanyList(options || []);
    }, [options]);

    return (
        <Popup
            open={open}
            onClose={onClose}
            popupStyle={{
                minWidth: 600,
                maxWidth: 600,
            }}
            modalStyle={{
                "& .MuiBox-root.css-ft9d2q": {
                    borderRadius: "10px 10px 0 0",
                },
            }}
            title="Add Company to System"
        >
            <Box
                sx={{
                    mx: 4,
                    mt: 2,
                    mb: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                }}
            >
                <Box sx={{ display: "flex", gap: 1 }}>
                    <Typography sx={{ fontSize: "11px", minWidth: 130, fontWeight: 700 }}>
                        Current Company List:
                    </Typography>
                    <Box
                        sx={{
                            backgroundColor: "#D0D5DE",
                            width: "100%",
                            maxHeight: 120,
                            overflow: "auto",
                            borderRadius: "5px",
                            py: 2,
                            px: 3,
                            display: "flex",
                            flexDirection: "column",
                            gap: 1.5,
                        }}
                    >
                        {companyList
                            .reduce((rows, item, index) => {
                                if (index % 2 === 0) rows.push([]);
                                rows[rows.length - 1].push(item);
                                return rows;
                            }, [])
                            .map((row, rowIndex) => (
                                <Box
                                    key={rowIndex}
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    {row.map((item, itemIndex) => (
                                        <Box
                                            key={itemIndex}
                                            sx={{
                                                width: "48%",
                                            }}
                                        >
                                            ● {item.label}
                                        </Box>
                                    ))}
                                </Box>
                            ))}
                    </Box>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 1 }}>
                    <Typography sx={{ fontSize: "11px", minWidth: 113, fontWeight: 700 }}>
                        New Company Name:
                    </Typography>
                    <TextField
                        value={addNewCompanyName}
                        onChange={(event) => {
                            setAddNewCompanyName(event.target.value);
                        }}
                        placeholder="Please Enter the Company Name..."
                        variant="outlined"
                        sx={textFieldStyle}
                        inputProps={{ maxLength: 50 }}
                    />
                    <Button
                        disabled={!addNewCompanyName}
                        onClick={addNewCompany}
                        variant="contained"
                        color={addNewCompanyName === "" ? "primary" : "secondary"}
                        sx={buttonStyle}
                    >
                        Add
                    </Button>
                </Box>
            </Box>
        </Popup>
    );
};

export default AddNewCompanyPopup;
